export default __webpack_public_path__ + "static/media/Finished.b375433e.png";